import * as React from 'react';
import Svg, {
  SvgProps,
  G,
  Path,
  Defs,
  LinearGradient,
  Stop,
} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={33}
    height={29}
    viewBox={'0 0 33 29'}
    {...props}
    fill={'none'}
    stroke={'none'}>
    <G filter="url(#a)">
      <Path
        fill="url(#b)"
        fillOpacity={0.85}
        d="m16.5 19-5.63-8.25h11.26L16.5 19Z"
      />
    </G>
    <Defs>
      <LinearGradient
        id="b"
        x1={16.938}
        x2={16.938}
        y1={19}
        y2={8}
        gradientUnits="userSpaceOnUse">
        <Stop stopColor={props.fill || '#009F9C'} />
        <Stop offset={1} stopColor={props.fill || '#007BB2'} />
      </LinearGradient>
    </Defs>
  </Svg>
);
export default SvgComponent;
